import React from "react";

const NeutralStudentLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <g
            stroke={color}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path
                className="prefix__cls-1"
                d="M17.94 16.89l-2.8-.77m-5.29 0l-2.78.78m10.6-10.61V11c0 3.1-3.62 6.21-5.17 6.21S7.33 14.05 7.33 11V6.29m5.17-1.55l11.9-2.07L12.5.6.6 2.67z"
            />
            <path
                className="prefix__cls-1"
                d="M7.33 3.84v2.45s1.55 1.55 5.17 1.55 5.17-1.55 5.17-1.55V3.84M3.19 3.12v3.69m0 0l-1.56 7.24h3.11L3.19 6.81M7.07 16.9l-3.78 1A4.13 4.13 0 00.6 21.81v2.59h23.8v-2.59a4.13 4.13 0 00-2.68-3.87l-3.78-1.05-5.44 5.44z"
            />
        </g>
    </svg>
);

export default NeutralStudentLine;
